export default __webpack_public_path__ + "static/N0190-5660e3a03e909b3c0d6d2532dbb0eb78.png";